import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {RolesEnum} from '../core/security/roles.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {EventsFlowListComponent} from './list/list.component';
import {EventsFlowEditComponent} from './edit/edit.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'list',
        component: EventsFlowListComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.EventsFlowGroup,
          package: ModulesEnum.EventsFlowModule,
          permissions: [RolesEnum.EventsFlowView, RolesEnum.EventsFlowEdit, RolesEnum.EventsFlowDelete],
          animation: 'main',
          meta: {
            title: 'Events Flow',
            override: true,
            description: 'Events Flow',
            inSideMenu: true,
            iconClass: 'material-icons',
            iconClassCode: 'account_tree',
          }
        }
      },
      {
        path: 'edit/:id',
        component: EventsFlowEditComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.EventsFlowGroup,
          package: ModulesEnum.EventsFlowModule,
          permissions: [RolesEnum.EventsFlowEdit, RolesEnum.EventsFlowDelete],
          meta: {
            title: 'Edit Events Flow',
            override: true,
            description: 'Edit Events Flow',
            inSideMenu: false,
            iconClass: 'material-icons',
            iconClassCode: 'account_tree',
          }
        }
      }
    ]
  }
];
